// Developer messages show in preview/dev only; the live (production) build stays silent.
const SHOW_DEV_MESSAGES = process.env.NODE_ENV !== 'production';

export function logError(message, error) {
  if (SHOW_DEV_MESSAGES) console.error(message, error);
}
